export default function transformOptions(tags) {
  return tags.map((tag) => ({
    label: tag.name,
    value: tag.id,
  }));
}
